import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22font.config.ts%22,%22import%22:%22IBM_Plex_Sans_Arabic%22,%22arguments%22:[{%22subsets%22:[%22arabic%22],%22weight%22:[%22400%22,%22500%22,%22600%22,%22700%22],%22preload%22:false,%22variable%22:%22--font-ibm-plex-arabic%22}],%22variableName%22:%22fontIBMPlexArabic%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'IBM Plex Sans Arabic', 'IBM Plex Sans Arabic Fallback'",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
